import { render } from "./ResultApp.vue?vue&type=template&id=23ce53fc"
import script from "./ResultApp.vue?vue&type=script&lang=js"
export * from "./ResultApp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\pc\\desktop\\quiz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__